import {BottomSheetDialog, Toast} from 'components';
import React, {useImperativeHandle, useRef} from 'react';
import {Platform} from 'react-native';
import {navigate, uploadFile} from 'services';
import {getImageCamera, getImageLibrary, getUuid} from 'utils';
import ComActionUpload from '../DigitalSignature/ComActionUpload';

const Comp = (
  props: {
    setLoadingPhotoAfter: any;
    setLoadingPhotoBefore: any;
    setPhotoBefore: any;
    setPhotoAfter: any;
    setLoading: any;
    onConfirm: (base64Uri: string) => void;
  },
  ref,
) => {
  const {
    setLoadingPhotoAfter,
    setLoadingPhotoBefore,
    setPhotoBefore,
    setPhotoAfter,
    setLoading,
    onConfirm,
  } = props;
  const bottomSheetUpload = useRef<any>(null);
  const bottomSheetUploadSign = useRef<any>(null);
  const imageUpload = useRef<'before' | 'after'>('before');

  useImperativeHandle(ref, () => ({
    showUploadImage: (img: 'before' | 'after') => {
      imageUpload.current = img;
      bottomSheetUpload.current.show();
    },
    showUploadSign: () => {
      bottomSheetUploadSign.current.show();
    },
  }));

  const hide = (cb?: () => void) => {
    if (bottomSheetUpload?.current) {
      bottomSheetUpload?.current.hide().then(() => {
        cb && cb();
      });
    }
  };
  const hideSign = (cb?: () => void) => {
    if (bottomSheetUploadSign?.current) {
      bottomSheetUploadSign?.current.hide().then(() => {
        cb && cb();
      });
    }
  };

  const doActionDrawline = async (image: any) => {
    if (!image) return;
    const base64Uri = image?.uri;
    onConfirm(base64Uri);
    return;
  };

  const onUploadImage = async (r: any) => {
    try {
      if (imageUpload.current == 'before') {
        setLoadingPhotoBefore(true);
      } else {
        setLoadingPhotoAfter(true);
      }
      const dataUpload: any = await uploadFile({
        fileBase64: r.base64,
      });
      if (dataUpload) {
        if (imageUpload.current == 'before') {
          setPhotoBefore({...r, ...dataUpload, dataUpload});
        } else {
          setPhotoAfter({...r, ...dataUpload, dataUpload});
        }
      } else {
        Toast.show({
          content: 'alert.daxayraloi',
          multilanguage: true,
        });
      }
    } catch (error) {
    } finally {
      setLoadingPhotoAfter(false);
      setLoadingPhotoBefore(false);
    }
  };

  return (
    <>
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetUploadSign}>
        <ComActionUpload
          onDrawline={() => {
            hideSign(() => {
              navigate('SignatureDraw', {
                data: {
                  flowApp: 'ChangeCMNDtoCCCD',
                },
                callback: (t: string) => {
                  doActionDrawline({
                    uri: t,
                  });
                },
              });
            });
          }}
          isDrawline={true}
          onCancel={() => {
            hideSign();
          }}
          onCamera={async () => {
            try {
              if (Platform.OS === 'ios') {
                await getImageCamera()
                  .then(async (image: any) => {
                    hideSign();
                    if (image[0]) {
                      return doActionDrawline(image[0]);
                    }
                  })
                  .catch(() => {
                    hideSign();
                  });
                return;
              }
              hideSign(async () => {
                await getImageCamera().then(async (image: any) => {
                  if (image[0]) {
                    return doActionDrawline(image[0]);
                  }
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
              }
            } finally {
              hideSign();
            }
          }}
          onGallery={async () => {
            try {
              if (Platform.OS === 'ios') {
                await getImageLibrary()
                  .then(async (image: any) => {
                    hideSign();
                    return doActionDrawline(image[0]);
                  })
                  .catch(() => {
                    hideSign();
                  });
                return;
              }
              hideSign(async () => {
                await getImageLibrary().then(async (image: any) => {
                  return doActionDrawline(image[0]);
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
                return;
              }
            } finally {
              hideSign();
            }
          }}
        />
      </BottomSheetDialog>
      <BottomSheetDialog
        style={{
          flexDirection: 'column',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
        ref={bottomSheetUpload}>
        <ComActionUpload
          onCancel={() => {
            hide();
          }}
          onCamera={async () => {
            try {
              if (Platform.OS === 'ios') {
                await getImageCamera()
                  .then(async (image: any) => {
                    hide();
                    if (image[0]) {
                      return onUploadImage(image[0]);
                    }
                  })
                  .catch(() => {
                    hide();
                  });
                return;
              }
              hide(async () => {
                await getImageCamera().then(async (image: any) => {
                  if (image[0]) {
                    return onUploadImage(image[0]);
                  }
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
              }
            } finally {
              hide();
            }
          }}
          onGallery={async () => {
            try {
              if (Platform.OS === 'ios') {
                await getImageLibrary()
                  .then(async (image: any) => {
                    hide();
                    return onUploadImage(image[0]);
                  })
                  .catch(() => {
                    hide();
                  });
                return;
              }
              hide(async () => {
                await getImageLibrary().then(async (image: any) => {
                  return onUploadImage(image[0]);
                });
              });
            } catch (error) {
              if (!!error) {
                Toast.show({
                  content: 'alert.daxayraloi',
                  multilanguage: true,
                });
                return;
              }
            } finally {
              hide();
            }
          }}
        />
      </BottomSheetDialog>
    </>
  );
};

export default React.forwardRef(Comp);
